import React from 'react'
import "./Maqolalar.scss";

function Maqolalar() {
  return (
    <div className="maqolalar">
      <h1>
      Maqolalar
      </h1>
    </div>
  )
}

export default Maqolalar
